import moment from 'moment';
import React from 'react';

import { changeDateFormat, getNumberUnit, getUserInfo, isCRMManagement, isDirector } from '@utils/Util';

export const currentStageColumns = [
	{ label: 'Active', value: 'ACTIVE' },
	{ label: 'On-boarded', value: 'ON_BOARDED' },
	{ label: 'On-boarding', value: 'ON_BOARDING' },
	{ label: 'Pipeline', value: 'PIPELINE' },
	{ label: 'Archived', value: 'ARCHIVE' }
];

export const staticColumns = [
	{ label: 'On Shipment', value: 'ON_SHIPMENT' },
	{ label: 'Production', value: 'RUNNING' },
	{ label: 'Shipment Completed', value: 'COMPLETED' },
	{ label: 'Pending - PI', value: 'PROFORMA_INVOICE' },
	{ label: 'Pending - SC', value: 'SALES_CONTRACT' }
];
export const statusList = [
	{ label: 'Due soon', value: 'DUE_SOON' },
	{ label: 'Red alert', value: 'RED_ALERT' },
	{ label: 'Safe', value: 'SAFE' },
	{ label: 'Shipped', value: 'SHIPPED' },
	{ label: 'Unsafe', value: 'UNSAFE' }
];

export const brandTabs = {
	OVERVIEW: 'OVERVIEW',
	ABOUT: 'ABOUT',
	MARKET_STATUS: 'MARKET_STATUS',
	STYLES: 'STYLES',
	DEPARTMENT_CATEGORIES: 'DEPARTMENT_CATEGORIES',
	NITEX_OPS_TEAM: 'NITEX_OPS_TEAM',
	BUYER_AND_BDM: 'BUYER_AND_BDM',
	SUPPLIER: 'SUPPLIER',
	BRAND_TEAM: 'BRAND_TEAM',
	REQUIRED_CERTIFICATES: 'REQUIRED_CERTIFICATES'
};

export const getPercentage = (n1, n2) => {
	let percentage = (n1 / n2) * 100;
	let value = percentage.toFixed(2);
	if (!isNaN(value)) {
		return `(${value}%)`;
	}
};

export const removeDuplicateQueryParams = (queryString) => {
	let [path, params] = queryString.split('?');
	return path + '?' + new URLSearchParams(Object.fromEntries(new URLSearchParams(params))).toString();
};

export const getDateLabel = (filterData) => {
	if (filterData.dateRange) {
		return `- ${filterData.dateRange[0].label}`;
	} else {
		return '';
	}
};

export const slideSettings = {
	dots: false,
	infinite: false,
	speed: 500,
	slidesToShow: 4,
	// marginRight: 16,
	slidesToScroll: 4,
	initialSlide: 0,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
				infinite: true,
				dots: true
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
				initialSlide: 2
			}
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
};

const calculateTotalPercentage = (totalApproved, totalAchievedAmount) => {
	if (totalApproved === 0) totalApproved = 1;
	return ((totalAchievedAmount / totalApproved) * 100).toFixed(2);
};

export const getAchievedPercentage = (totalApproved, totalAchievedAmount) => {
	let percentage = calculateTotalPercentage(totalApproved, totalAchievedAmount);
	return percentage > 90 ? 'green' : percentage >= 70 && percentage <= 90 ? 'yellow_dark_01' : 'red';
};

export const getAcManagerId = () => {
	if (!isDirector() && !isCRMManagement()) {
		return getUserInfo().id;
	} else {
		return undefined;
	}
};

export const getLastMonthsDate = (numberOfMonths) => {
	const currentDate = moment();
	return currentDate.clone().subtract(numberOfMonths, 'months').format('YYYY-MM-DD');
};

export const getNextMonthsDate = (numberOfMonths) => {
	const currentDate = moment();
	return currentDate.clone().add(numberOfMonths, 'months').format('YYYY-MM-DD');
};

export const processCustomCalenderDate = (startDate, endDate, label) => {
	return {
		name: 'dateRange',
		type: 'dateRange',
		key: `${startDate}_${endDate}`,
		value: `${changeDateFormat(startDate, 'YYYY-MM-DD', 'DD MMM, YYYY')} - ${changeDateFormat(
			endDate,
			'YYYY-MM-DD',
			'DD MMM, YYYY'
		)}`,
		identifier: 'dateRange',
		label: label
			? label
			: `${changeDateFormat(startDate, 'YYYY-MM-DD', 'MMM YYYY')} - ${changeDateFormat(
					endDate,
					'YYYY-MM-DD',
					'MMM YYYY'
				)}`
	};
};

export const getCRMBrandWisePowerBiURL = () => {
	const hostName = window.location.toString();
	if (hostName.indexOf('https://admin.nitex.com') > -1) {
		return 'https://app.powerbi.com/view?r=eyJrIjoiOGMzMzk3NzctMmFmZS00ZmUxLTliMzAtMWY4MTRjNWY5YjcyIiwidCI6ImY2N2JlZDYxLTQ0OTQtNGIwZS1hZDE0LWVhOTNjZmZhYWJjZiIsImMiOjEwfQ%3D%3D&filter=powerbi_data/BRAND_ID%20eq%20%27';
	} else {
		return 'https://app.powerbi.com/reportEmbed?reportId=f07419e3-0930-4e24-8f05-a3dfff1e8c5a&autoAuth=true&ctid=f67bed61-4494-4b0e-ad14-ea93cffaabcf&filter=powerbi_data_2703/BRAND_ID%20eq%20%27';
	}
};

const commonFileTypes =
	'application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*';
const allDocType = '*';

export const acceptFileType = (fileType) => {
	switch (fileType) {
		case 'image':
			return 'image/*';
		case 'imageDocument':
			return commonFileTypes;
		case 'allDocType':
			return allDocType;
		case 'imageAndPdf':
			return 'application/pdf, image/*';
		default:
			return commonFileTypes;
	}
};

export const getPercentageValue = (n1 = 0, n2 = 0) => {
	let percentage = (n1 / (n1 + n2)) * 100;
	return percentage ? percentage.toFixed(2) : '0';
};

export const calculateTotal = (targets, fieldName) => {
	return targets?.reduce((total, item) => {
		return total + item[fieldName];
	}, 0);
};

export const getMonthName = (monthNumber) => {
	const date = new Date();
	date.setMonth(monthNumber - 1);

	return date.toLocaleString('en-US', {
		month: 'long'
	});
};

export const cvrProbabilityTypes = [
	{
		type: 'REQUEST',
		currentLabel: 'Request',
		nextType: 'PARTIALLY_APPROVED',
		nextLabel: 'Partially Approved',
		fieldName: 'requestToPartiallyApproved'
	},
	{
		type: 'PARTIALLY_APPROVED',
		currentLabel: 'Partially Approved',
		nextType: 'APPROVED',
		nextLabel: 'Approved',
		fieldName: 'partiallyApproveToApproved'
	},
	{
		type: 'APPROVED',
		currentLabel: 'Approved',
		nextType: 'PO_RECEIVED',
		nextLabel: 'Po Received',
		fieldName: 'approvedToPoReceived'
	}
	// {
	// 	type: 'PO_RECEIVED',
	// 	currentLabel: 'PO Received',
	// 	nextType: 'ORDER_PLACED',
	// 	nextLabel: 'Order Placed',
	// 	fieldName: 'poReceivedToOrderPlaced'
	// }
];

export const probabilityTypes = [
	{ type: 'REQUEST', label: 'Request', percentage: 30 },
	{ type: 'PARTIALLY_APPROVED', label: 'Partially Approved', percentage: 50 },
	{ type: 'APPROVED', label: 'Approved', percentage: 70 },
	{ type: 'PO_RECEIVED', label: 'PO Received', percentage: 100 },
	// { type: 'ORDER_PLACED', label: 'Order Placed', percentage: 100 },
	{ type: 'REJECTED', label: 'Rejected', percentage: 0 }
];

export const generateYears = (startYear, endYear) => {
	let years = [];
	for (let year = startYear; year <= endYear; year++) {
		years.push(year);
	}
	return years;
};

export const generateRandNumber = () => {
	return Math.floor(Math.random() * 10000000000000) + '_' + Date.now();
};

export const setDefaultValueForTree = (apiData, fieldData) => {
	const setChildTargetResponse = (item, n, rootInfo) => {
		if (item?.[fieldData]?.length > 0) {
			n++;
			item[fieldData] = item[fieldData].map((target) => {
				target.uId = `${n}_${generateRandNumber()}`;
				target.parentUId = rootInfo.uId;
				target.isChildOpen = false;
				target.isOpen = false;
				target.parentTargetId = item.id;
				target.immediateParentInfo = item;
				target.rootInfo = rootInfo;
				return setChildTargetResponse(target, n, rootInfo);
			});
		}
		return item;
	};

	return apiData.map((item) => {
		let n = 1;
		item.uId = `${n}_${generateRandNumber()}`;
		item.isChildOpen = false;
		item.isOpen = true;
		item.parentTargetId = null;
		item.isRootNode = true;
		return setChildTargetResponse(item, n, item);
	});
};

export const toggleTreeList = (data, isRootNode, nodeInfo, fieldData) => {
	const toggleChildResponse = (item, isOpen) => {
		if (item?.[fieldData]?.length > 0) {
			item[fieldData] = item[fieldData].map((target) => ({
				...target,
				isOpen,
				isChildOpen: isOpen,
				[fieldData]: toggleChildResponse(target, isOpen)[fieldData]
			}));
		}
		return item;
	};

	if (isRootNode) {
		return data?.map((item) => {
			if (item.uId === nodeInfo.uId) {
				const isChildOpen = !item.isChildOpen;
				item[fieldData] = item[fieldData].map((target) => ({
					...target,
					isOpen: isChildOpen
				}));
				if (!isChildOpen) {
					item = toggleChildResponse({ ...item }, false);
				}
				return { ...item, isChildOpen };
			}
			return { ...item };
		});
	} else {
		const manageChilds = (item, currentTreeLevel, selectedTreeLevel) => {
			const childList = item[fieldData] || [];
			if (childList.length > 0) {
				item[fieldData] = childList.map((child) => {
					if (currentTreeLevel === selectedTreeLevel && child.uId === nodeInfo.uId) {
						const isChildOpen = !child.isChildOpen;
						const newChildList = child[fieldData] || [];
						newChildList.forEach((grandChild) => {
							grandChild.isChildOpen = false;
							grandChild.isOpen = isChildOpen;
						});
						if (!isChildOpen) {
							toggleChildResponse(child, false);
						}
						return {
							...child,
							isChildOpen,
							[fieldData]: newChildList
						};
					} else {
						manageChilds(child, currentTreeLevel + 1, selectedTreeLevel);
						return { ...child };
					}
				});
			}
		};

		const selectedTreeLevel = parseInt(nodeInfo.uId.split('_')[0]);
		return data?.map((item) => {
			if (item.uId === nodeInfo.parentUId) {
				manageChilds(item, 2, selectedTreeLevel);
			}
			return { ...item };
		});
	}
};

export const renderProfilePic = (user) => {
	if (user?.profilePicDocument?.docUrl) {
		return <img src={user?.profilePicDocument?.docUrl} alt="people" className="people" />;
	} else {
		let nameList = user?.name?.split(' ') || [];
		let nameStr = nameList?.[0]?.charAt(0) || '' + nameList?.[1]?.charAt(0) || '';
		return <span className="placeholder-name">{nameStr}</span>;
	}
};

export const CrmDashboardBarChartOptions = {
	scales: {
		x: {
			grid: {
				color: '#EFF1F3',
				display: false
			}
		},
		y: {
			grid: {
				color: '#EFF1F3'
			},
			ticks: {
				callback: function (value) {
					return getNumberUnit(value);
				}
			}
		}
	},
	plugins: {
		tooltip: {
			callbacks: {
				title: (tooltipItem) => {
					return tooltipItem[0]?.dataset?.label;
				},
				label: function (tooltipItem) {
					return `$${getNumberUnit(tooltipItem.raw)}`;
				}
			}
		}
	}
};

export const dashboardComparisonColors = ['#BDF3CB', '#8EE7A5', '#2FCF5A', '#009C2A', '#00751F'];

export const repeatColors = (colors, n) => {
	const repeatedColors = [];
	const colorsLength = colors.length;
	for (let i = 0; i < n; i++) {
		repeatedColors.push(colors[i % colorsLength]);
	}
	return repeatedColors;
};

export const groupByYear = (data) => {
	const groupedData = {};
	Object.values(data).forEach((quarters) => {
		quarters.forEach((record) => {
			if (!groupedData[record.year]) {
				groupedData[record.year] = [];
			}
			groupedData[record.year].push(record);
		});
	});

	return groupedData;
};
export const getProductIds = (products) => {
	return products.map((product) => product.id);
};
